var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelebrateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "celebrate-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "411_Progress-Bar_Success",
    transform: "translate(-215.000000, -42.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_confetti-party-happy-birthday_3612559",
    transform: "translate(215.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4,7.4 C24.4,7.1790861 24.2209139,7 24,7 C23.7790861,7 23.6,7.1790861 23.6,7.4 C23.6,8.0627417 23.0627417,8.6 22.4,8.6 C22.1790861,8.6 22,8.7790861 22,9 C22,9.2209139 22.1790861,9.4 22.4,9.4 C23.0627417,9.4 23.6,9.9372583 23.6,10.6 C23.6,10.8209139 23.7790861,11 24,11 C24.2209139,11 24.4,10.8209139 24.4,10.6 C24.4,9.9372583 24.9372583,9.4 25.6,9.4 C25.8209139,9.4 26,9.2209139 26,9 C26,8.7790861 25.8209139,8.6 25.6,8.6 C24.9372583,8.6 24.4,8.0627417 24.4,7.4 Z M24,9.4124 C23.8834755,9.25547535 23.7445247,9.11652453 23.5876,9 C23.7445247,8.88347547 23.8834755,8.74452465 24,8.5876 C24.1165245,8.74452465 24.2554753,8.88347547 24.4124,9 C24.2554753,9.11652453 24.1165245,9.25547535 24,9.4124 L24,9.4124 Z",
    id: "iconfinder_confetti-party-happy-birthday_3612559-shape1",
    fill: "#FDBD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6,1.6 C18.9372583,1.6 18.4,1.0627417 18.4,0.4 C18.4,0.1790861 18.2209139,0 18,0 C17.7790861,0 17.6,0.1790861 17.6,0.4 C17.6,1.0627417 17.0627417,1.6 16.4,1.6 C16.1790861,1.6 16,1.7790861 16,2 C16,2.2209139 16.1790861,2.4 16.4,2.4 C17.0627417,2.4 17.6,2.9372583 17.6,3.6 C17.6,3.8209139 17.7790861,4 18,4 C18.2209139,4 18.4,3.8209139 18.4,3.6 C18.4,2.9372583 18.9372583,2.4 19.6,2.4 C19.8209139,2.4 20,2.2209139 20,2 C20,1.7790861 19.8209139,1.6 19.6,1.6 Z M18,2.4124 C17.8834755,2.25547535 17.7445247,2.11652453 17.5876,2 C17.7445247,1.88347547 17.8834755,1.74452465 18,1.5876 C18.1165245,1.74452465 18.2554753,1.88347547 18.4124,2 C18.2554753,2.11652453 18.1165245,2.25547535 18,2.4124 Z",
    id: "iconfinder_confetti-party-happy-birthday_3612559-shape2",
    fill: "#FDBD40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "iconfinder_confetti-party-happy-birthday_3612559-polygon-1",
    fill: "#EF9A9A",
    points: "5.2772696 23 7 22.1210182 5.2772696 15 4 17.9135685"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "iconfinder_confetti-party-happy-birthday_3612559-polygon-2",
    fill: "#FD9598",
    points: "15.0111224 17 15.300279 18 15.9888776 17.7190519"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "iconfinder_confetti-party-happy-birthday_3612559-polygon-3",
    fill: "#EF9A9A",
    points: "3 24.8311703 2.42616415 21 0 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "iconfinder_confetti-party-happy-birthday_3612559-polygon-4",
    fill: "#EF9A9A",
    points: "7.33283968 10 6 12.4863568 8.25368971 22 10 21.1006448"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "iconfinder_confetti-party-happy-birthday_3612559-polygon-5",
    fill: "#EF9A9A",
    points: "10 12 11.9569702 20 14 19.0652265 12.9354553 14.64946"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "iconfinder_confetti-party-happy-birthday_3612559-polygon-6",
    fill: "#F34236",
    points: "2 21.0293883 2.79711906 24 5 23.1810464 3.60985769 18"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "iconfinder_confetti-party-happy-birthday_3612559-polygon-7",
    fill: "#F34236",
    points: "6.40622646 22 8 21.2033561 6.16444891 12 5 14.9480063"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "iconfinder_confetti-party-happy-birthday_3612559-polygon-8",
    fill: "#F34236",
    points: "8 10 10.3171289 21 12 20.2033037 10.3855254 12.5408725"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "iconfinder_confetti-party-happy-birthday_3612559-polygon-9",
    fill: "#F34236",
    points: "16 18.2988538 15.7108434 17.236511 13 15 14.0879518 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,2.22222222 C24.1851852,3.03703704 24.7604444,3.61433333 23.9444074,4.42996296 C23.1283704,5.24559259 22.5527037,4.66951852 21.7366667,5.48555556 C20.9206296,6.30159259 21.4983333,6.87603704 20.6839259,7.69044444 C19.8695185,8.50485185 19.2934444,7.92877778 18.4794444,8.74277778 C17.6654444,9.55677778 18.2415185,10.1332593 17.4271111,10.9472593 C16.6127037,11.7612593 16.037037,11.1851852 15.2222222,12 L14,10.7777778 C14.8148148,9.96296296 15.3904815,10.5394444 16.2048889,9.72503704 C17.0192963,8.91062963 16.4444444,8.33333333 17.2592593,7.52055556 C18.0740741,6.70777778 18.6497407,7.28262963 19.4637407,6.46822222 C20.2777407,5.65381481 19.7020741,5.07774074 20.5164815,4.26333333 C21.3308889,3.44892593 21.9085926,4.02337037 22.7242222,3.20774074 C23.5398519,2.39211111 22.962963,1.81481481 23.7777778,1 L25,2.22222222 Z",
    id: "iconfinder_confetti-party-happy-birthday_3612559-path1",
    fill: "#F34236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,15.2000108 C24.7552941,14.1995121 23.1399846,13.6309308 21.4545455,13.6000324 C18.7272727,13.6000324 16.4545455,16 16.4545455,16 L16,14.000027 C16,14.000027 18.7272727,12.000054 21.4545455,12.000054 C23.0713991,11.9945372 24.6536006,12.4122327 26,13.2000378 L26,15.2000108 Z",
    id: "iconfinder_confetti-party-happy-birthday_3612559-path2",
    fill: "#36AFAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,15.2000108 C24.7552941,14.1995121 23.1399846,13.6309308 21.4545455,13.6000324 C18.7272727,13.6000324 16.4545455,16 16.4545455,16 L16,14.000027 C16,14.000027 18.7272727,12.000054 21.4545455,12.000054 C23.0713991,11.9945372 24.6536006,12.4122327 26,13.2000378 L26,15.2000108 Z",
    id: "iconfinder_confetti-party-happy-birthday_3612559-path3",
    fill: "#00C4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8313274,0 C11.8226435,1.24882028 12.3826555,2.86599933 12.4071865,4.55069962 C12.3972329,7.27648555 10,9.53616209 10,9.53616209 L11.9907265,10 C11.9907265,10 13.9898141,7.28375432 13.9997677,4.55796838 C14.0111876,2.94211071 13.6012435,1.35887275 12.8220539,0.00954025077 L10.8313274,0 Z",
    id: "iconfinder_confetti-party-happy-birthday_3612559-path4",
    fill: "#36AFAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8313274,0 C11.8226435,1.24882028 12.3826555,2.86599933 12.4071865,4.55069962 C12.3972329,7.27648555 10,9.53616209 10,9.53616209 L11.9907265,10 C11.9907265,10 13.9898141,7.28375432 13.9997677,4.55796838 C14.0111876,2.94211071 13.6012435,1.35887275 12.8220539,0.00954025077 L10.8313274,0 Z",
    id: "iconfinder_confetti-party-happy-birthday_3612559-path5",
    fill: "#00C4B4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrateIcon);
export default __webpack_public_path__ + "static/media/celebrate-icon.a3b9bf43.svg";
export { ForwardRef as ReactComponent };